import * as am4core from "@amcharts/amcharts4/core";

export const CHART_MAX_VALUES = 10;

export const ENVIRONMENTS = {
  DEVELOPMENT: "development",
  PRODUCTION: "production",
};

export const PROGRAM_TABLES = {
  ALL_PROGRAMS: "all_programs",
  WISH_LIST: "whish_list",
};

export const POSITIONS = {
  AGENT: "A",
  OUTLET_MANAGER: "OM",
  MANAGER: "M",
  SENIOR_MANAGER: "SM",
  GENERAL_MANAGER: "GM",
  VICE_PRESIDENT: "VP",
};

export const POSITIONS_LABEL = {
  [POSITIONS.AGENT]: "Promoter/CSR",
  [POSITIONS.OUTLET_MANAGER]: "Outlet Manager",
  [POSITIONS.MANAGER]: "Manager",
  [POSITIONS.SENIOR_MANAGER]: "Senior Manager",
  [POSITIONS.GENERAL_MANAGER]: "General Manager",
  [POSITIONS.VICE_PRESIDENT]: "Vice President",
};

// Top to bottom
export const POSITION_HIERARCHY = [
  POSITIONS.VICE_PRESIDENT,
  POSITIONS.GENERAL_MANAGER,
  POSITIONS.SENIOR_MANAGER,
  POSITIONS.MANAGER,
  POSITIONS.OUTLET_MANAGER,
  POSITIONS.AGENT,
];

export const CHART_COLORS = [
  am4core.color("#0063a4"),
  am4core.color("#0063a4").lighten(0.1),
  am4core.color("#0063a4").lighten(0.2),
  am4core.color("#0063a4").lighten(0.3),
  am4core.color("#0063a4").lighten(0.4),
  am4core.color("#f89d21").lighten(0.4),
  am4core.color("#f89d21").lighten(0.3),
  am4core.color("#f89d21").lighten(0.2),
  am4core.color("#f89d21").lighten(0.1),
  am4core.color("#f89d21"),
];

export const RANDOM_CHART_COLORS = [
  am4core.color("#0063a4").lighten(0.4),
  am4core.color("#f89d21").lighten(0.4),
  am4core.color("#0063a4").lighten(0.3),
  am4core.color("#f89d21").lighten(0.3),
  am4core.color("#0063a4").lighten(0.2),
  am4core.color("#f89d21").lighten(0.2),
  am4core.color("#0063a4").lighten(0.1),
  am4core.color("#f89d21").lighten(0.1),
  am4core.color("#0063a4"),
  am4core.color("#f89d21"),
];

export const CHART_COLORS_PRIMARY = [
  am4core.color("#0063a4"),
  am4core.color("#0063a4"),
  am4core.color("#0063a4"),
  am4core.color("#0063a4"),
  am4core.color("#0063a4"),
  am4core.color("#0063a4"),
  am4core.color("#0063a4"),
  am4core.color("#0063a4"),
  am4core.color("#0063a4"),
  am4core.color("#0063a4"),
];

export const CHART_COLORS_TWO = [
  am4core.color("#0063a4"),
  am4core.color("#f89d21"),
];

export const CHART_COLORS_THREE = [
  am4core.color("#0063a4"),
  am4core.color("#f89d21"),
  am4core.color("#0063a4").lighten(0.1),
];

export const ADMIN_DEFAULT_POSITION = POSITIONS.VICE_PRESIDENT;

export const QUARTERS_VALUE = {
  Q1: "1Q",
  Q2: "2Q",
  Q3: "3Q",
  Q4: "4Q",
};
export const QUARTERS = [
  { label: "Quarter 1", value: QUARTERS_VALUE.Q1 },
  { label: "Quarter 2", value: QUARTERS_VALUE.Q2 },
  { label: "Quarter 3", value: QUARTERS_VALUE.Q3 },
  { label: "Quarter 4", value: QUARTERS_VALUE.Q4 },
];

export const MONTHS = [
  { label: "Jan", value: 1 },
  { label: "Feb", value: 2 },
  { label: "Mar", value: 3 },
  { label: "Apr", value: 4 },
  { label: "May", value: 5 },
  { label: "Jun", value: 6 },
  { label: "July", value: 7 },
  { label: "Aug", value: 8 },
  { label: "Sept", value: 9 },
  { label: "Oct", value: 10 },
  { label: "Nov", value: 11 },
  { label: "Dec", value: 12 },
];

export const REGION = [
  { label: "Muskat", value: "muskat" },
  { label: "Fuhud", value: "fuhad" },
  { label: "Adam", value: "adam" },
  { label: "Haima", value: "haima" },
  { label: "Fasad", value: "fasad" },
  { label: "Ibra", value: "Ibra" },
];

export const productColors = {
  Baqati: am4core.color("#f89d21").lighten(0.5),
  Hayyak: am4core.color("#0063a4").lighten(0.2),
  HBB: am4core.color("#975bd4").lighten(0.2),
  Upgrade: am4core.color("#d65eeb").lighten(0.1),
};

export const NOTIFICATION_CATEGORIES = {
  TRAINING: "TRAINING",
  NOTIFICATION: "NOTIFICATION",
  OFFER: "OFFER",
  QUIZ: "QUIZ",
};

export const FILE_TYPES = {
  PDF: "PDF",
  EXCEL: "EXCEL",
  VIDEO: "VIDEO",
};

export const SUPPORTED_FILE_TYPES = {
  [FILE_TYPES.PDF]: ["pdf"],
  [FILE_TYPES.EXCEL]: ["xls", "xlsx"],
  [FILE_TYPES.VIDEO]: ["mp4", "flv", "mkv", "webm", "ogg", "avi", "m4v", "3gp"],
};
